import { useEffect } from "react";
import brand from "@/config/brand";

const setMeta = (selector, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute("content", value);
};

export const useTitle = (pageTitle, description) => {
  useEffect(() => {
    const title = pageTitle
      ? `${pageTitle} — ${brand.name}`
      : `${brand.name} — ${brand.tagline}`;
    document.title = title;
    if (description) {
      setMeta('meta[name="description"]', description);
      setMeta('meta[property="og:title"]', title);
      setMeta('meta[property="og:description"]', description);
      setMeta('meta[name="twitter:title"]', title);
      setMeta('meta[name="twitter:description"]', description);
    }
  }, [pageTitle, description]);
};

export default useTitle;
